import React, { memo } from "react";

const Help = ({ children }: { children: any }) => (
  <span className="help">
    <i className="fas fa-question" />
    <div className="help-body">{children}</div>
  </span>
);
export default memo(Help);
